var cardTableTemplate = require('templates/cardTable.hbs');
var cardTableBenefitTemplate = require('templates/cardTable-benefit.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'cardTable',
  template: {
    'cardTable': cardTableTemplate,
    'cardTable-benefit':cardTableBenefitTemplate
  },
  bindEvents: function() {
    this.cloneTableToLock();
    this.onResize();
  },
  onResize:function(){
    var _self = this
    $(window).on('resize', function() {
      _self.cloneTableToLock();
    });
  },
  cloneTableToLock:function(){
    var _self=this;
    var $table= _self.$el.find('.js-table-container table');
    var cWidth = _self.$el.width();
    var tWidth = $table.outerWidth();
    var clonedTable = _self.$el.find('.l-cloned-table').length;
    if ($table.is(':visible') && (tWidth > cWidth) && (clonedTable < 1)){
      _self.$el.find('.l-desktop-table-container').addClass('l-scrollable-table-container');
      $table.find('th:first-child').addClass('t-fixed-col');
      $table.find('td:first-child').addClass('t-fixed-col');
      $table.clone(true).appendTo('.js-table-container').addClass('l-cloned-table');
    }
  }
});